@if ((currentLayoutType$ | async) === 'auth') {
  <app-auth-layout
    [isExistingCustomer]="isExistingCustomer"
    [currentUrl]="currentUrl$ | async"
  ></app-auth-layout>
}

@if ((currentLayoutType$ | async) === 'nude') {
  <app-nude-layout
    [isExistingCustomer]="isExistingCustomer"
    [currentUrl]="currentUrl$ | async"
  ></app-nude-layout>
}

@if ((currentLayoutType$ | async) === 'refer-a-friend') {
  <app-refer-a-friend-layout
    [currentUrl]="currentUrl$ | async"
  ></app-refer-a-friend-layout>
}

@if ((currentLayoutType$ | async) === 'customer-hub') {
  <app-customer-hub-layout
  ></app-customer-hub-layout>
}

@if ((currentLayoutType$ | async) === 'offers') {
  <app-offers-layout
    [currentUrl]="currentUrl$ | async"
  ></app-offers-layout>
}

<app-toast-notification-container></app-toast-notification-container>
